import { HttpService, WidgetStyle } from '@sdbn/appclient';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportPeriod } from './model/reportperiod';
import { Subscription } from 'rxjs';
import { ContextChange } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-report-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  reportingPeriods = [
    new ReportPeriod('DAY', 'Tagesreport', 'reporting.dashboard.period-day'),
    new ReportPeriod('MONTH', 'Monatsreport', 'reporting.dashboard.period-month'),
    new ReportPeriod('YEAR', 'Jahresreport', 'reporting.dashboard.period-year')
  ];

  selected = this.reportingPeriods[0]; // Default is day
  data: any;
  initialized = false;

  private languageSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private http: HttpService) {

    super();

    this.languageSubscription = translationService.languageSubject.subscribe(language => {

    });
  }

  chooseReportPeriod(item) {
    this.selected = item;
    this.loadReport(item);
  }

  isSelected(item: ReportPeriod): boolean {
    return this.selected === item;
  }

  private loadReport(period: ReportPeriod) {
    this.http.postWithContext(`${environment.reportingEndpoint}/dashboard`, { key: this.selected.key })
      .subscribe(
        response => { this.data = response; this.initialized = true; }
      );
  }


  ngOnInit() {
    this.loadReport(this.selected);
  }

  ngOnDestroy(): void {

    super.ngOnDestroy();

    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    for (const period of this.reportingPeriods) {
      if (period.key === this.widgetReference?.data?.period) {
        this.selected = period;
      }
    }
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
